<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加手机号</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 20px;">

        <el-row style="margin-bottom: 25px;" >
          <el-col :span="12" class="item" >
            <span style="padding: 5px;display: inline-block;">姓名:</span>
            <el-input placeholder="请输入姓名" v-model="addForm.name" maxlength="11" clearable
                      style="width:100%;margin-right:10px"></el-input>
          </el-col>

          <el-col :span="12" class="item">
            <span style="padding: 5px;display: inline-block;">手机号:</span>
            <el-input placeholder="请输入手机"  v-model="addForm.phone" maxlength="11" clearable
                      style="width:100%;margin-right:10px"></el-input>
          </el-col>
        </el-row>

      </div>
      <div class="modal-footer">

        <el-button :loading="loading" type="success" size="mini" @click="addSubmit">保存</el-button>

      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,

      tableLoading:false,

      addForm:{
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),

        name:'',
        phone:'',
        deviceQLSignCode:'',

      },


    }
  },
  components: {

  },
  methods: {
    init(deviceQLSignCode){

      this.addForm.deviceQLSignCode = deviceQLSignCode;

      this.addForm.name='';
      this.addForm.phone='';

    },

    closeSelf() {
      this.$emit("closeMe");
    },


    addSubmit(){

      if(this.addForm.name==''){
        return;
      }
      if(this.addForm.phone==''){
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceQLSign/AddPhone",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeMe");
          this.$emit("listBmd");

          this.$message.success("添加成功")

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

      })
    },


  }
}

</script>


<style lang="scss" scoped>

</style>
